
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"#282828","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.771 8.093l-.073-.097c-.39-.509-.847-.94-1.427-1.226-.382-.188-.78-.307-1.211-.25-.351.047-.621.216-.749.564-.078.216-.065.44-.028.663.01.065.036.099.101.112.062.013.125.039.185.06.608.22 1.12.592 1.596 1.021.493.445.94.941 1.362 1.458l.013.016a.676.676 0 001.17-.229l.098-.32c.429-1.372.912-2.726 1.568-4.01a15.359 15.359 0 011.811-2.79A16.875 16.875 0 0114.766.548c-.003-.005 0 .002 0-.003-3.452 1.471-5.773 3.993-6.995 7.551v-.002z"}}),_c('path',{attrs:{"d":"M7.88 14.5c-3.86 0-7-3.14-7-7A7.008 7.008 0 0110.193.89a.37.37 0 01-.245.697A6.27 6.27 0 001.62 7.5a6.27 6.27 0 006.262 6.262A6.27 6.27 0 0014.143 7.5a6.245 6.245 0 00-1.027-3.436.37.37 0 11.619-.406A6.967 6.967 0 0114.884 7.5c0 3.86-3.14 7-7 7H7.88z"}})])
          )
        }
      }
    